import { ComponentType } from 'react';
import { FiActivity, FiCpu, FiGrid } from 'react-icons/fi';
import { BiFolder } from 'react-icons/bi';
import { GiRadarSweep } from 'react-icons/gi';
import { MdInsights } from 'react-icons/md';
import { AiOutlineLineChart } from 'react-icons/ai';
import { PiSparkleFill } from 'react-icons/pi';
import { ReactComponent as ObservationDeckIcon } from 'app/assets/observation-deck-logo.svg';

export const landingDisplayLabels: Record<string, string> = {
  observationDeck: 'Observation Deck',
  nmsDashboard: 'NMS Dashboard',
  networkExplorer: 'Network Explorer',
  library: 'Library',
  synthetics: 'Synthetics',
  explorer: 'Data Explorer',
  alerting: 'Alerting',
  insights: 'Insights',
  dashboard: 'Dashboard',
  'saved-view': 'Saved View',
  'quick-view': 'Quick View',
  'market-intel': 'Market Intelligence',
  aiAdvisor: 'AI Advisor'
};

export const landingRoutes = {
  observationDeck: () => '/v4/home',
  nmsDashboard: () => '/v4/nms',
  networkExplorer: () => '/v4/core',
  library: () => '/v4/library',
  alerting: () => '/v4/alerting',
  insights: () => '/v4/core/insights',
  explorer: () => '/v4/core/explorer',
  synthetics: () => '/v4/synthetics',
  'market-intel': () => '/v4/service-provider/market-intel',
  dashboard: (v: string | number) => `/v4/library/dashboards/${v}`,
  'saved-view': (v: string | number) => `/v4/library/saved-views/${v}`,
  'quick-view': (v: string | number) => `/v4/core/quick-views/${v}`,
  aiAdvisor: () => '/v4/core/ai-advisor'
};

/**
 * Maps each landing page type key to the icon value accepted by the core `Icon` component —
 * either a react-icons component, an SVG ReactComponent, or a Blueprint icon name string.
 */
export const landingDisplayIcons: Record<string, ComponentType | string> = {
  observationDeck: ObservationDeckIcon,
  nmsDashboard: FiCpu,
  networkExplorer: FiActivity,
  library: BiFolder,
  synthetics: GiRadarSweep,
  explorer: FiActivity,
  alerting: 'shield',
  insights: MdInsights,
  dashboard: FiGrid,
  'saved-view': AiOutlineLineChart,
  'quick-view': 'linked-squares',
  'market-intel': 'heatmap',
  aiAdvisor: PiSparkleFill
};
